export enum EncumbranceTypes {
  CO_OWNERSHIP = 'CO_OWNERSHIP', // eslint-disable-line
  PLEDGE_OR_GUARANTEE = 'PLEDGE_OR_GUARANTEE', // eslint-disable-line
  USUFRUCT = 'USUFRUCT', // eslint-disable-line
  EMBARGO = 'EMBARGO', // eslint-disable-line
  RESTRICTIONS_ON_TRANSFERABILITY = 'RESTRICTIONS_ON_TRANSFERABILITY', // eslint-disable-line
  PURCHASE_OR_SALE_OPTIONS = 'PURCHASE_OR_SALE_OPTIONS', // eslint-disable-line
  SHAREHOLDER_AGREEMENTS = 'SHAREHOLDER_AGREEMENTS', // eslint-disable-line
  TAX_LIENS = 'TAX_LIENS', // eslint-disable-line
  REGISTRATION_ANNOTATIONS = 'REGISTRATION_ANNOTATIONS', // eslint-disable-line
  TRUSTS_OR_FIDUCIARIES = 'TRUSTS_OR_FIDUCIARIES', // eslint-disable-line
  OTHER = 'OTHER', // eslint-disable-line
}

export type EncumbranceOption = {
  label: string;
  value: EncumbranceTypes;
  description: string;
};

export const encumbranceOptions: EncumbranceOption[] = [
  {
    label: 'Co-ownership',
    value: EncumbranceTypes.CO_OWNERSHIP,
    description: 'When shares belong to multiple owners.',
  },
  {
    label: 'PledgeOrGuarantee',
    value: EncumbranceTypes.PLEDGE_OR_GUARANTEE,
    description:
      'Shares can be pledged as collateral for a loan or other obligation.',
  },
  {
    label: 'Usufruct',
    value: EncumbranceTypes.USUFRUCT,
    description:
      'Separation between the bare owner (formal holder) and the usufructuary (who enjoys dividends and economic rights).',
  },
  {
    label: 'Embargo',
    value: EncumbranceTypes.EMBARGO,
    description:
      'By court order, as a result of executive or bankruptcy proceedings.',
  },
  {
    label: 'RestrictionsOnTransferability',
    value: EncumbranceTypes.RESTRICTIONS_ON_TRANSFERABILITY,
    description:
      'Agreements on syndication, preemptive purchase rights, prior authorization clauses, etc.',
  },
  {
    label: 'PurchaseOrSaleOptions',
    value: EncumbranceTypes.PURCHASE_OR_SALE_OPTIONS,
    description:
      'Rights of a third party to acquire or sell shares under certain conditions.',
  },
  {
    label: 'ShareholderAgreements',
    value: EncumbranceTypes.SHAREHOLDER_AGREEMENTS,
    description:
      'Agreements between shareholders that affect the exercise of rights over shares.',
  },
  {
    label: 'TaxLiens',
    value: EncumbranceTypes.TAX_LIENS,
    description: 'Due to pending tax debts.',
  },
  {
    label: 'RegistrationAnnotations',
    value: EncumbranceTypes.REGISTRATION_ANNOTATIONS,
    description:
      'Regarding limitations or charges affecting their transferability.',
  },
  {
    label: 'TrustsOrFiduciaries',
    value: EncumbranceTypes.TRUSTS_OR_FIDUCIARIES,
    description: 'Especially in Anglo-Saxon jurisdictions.',
  },
  {
    label: 'Other',
    value: EncumbranceTypes.OTHER,
    description:
      'Another encumbrance type that does not fit the above categories.',
  },
];
